import React from 'react';
import PageLayout from '../../../components/common/PageLayout';
import { ShopifyAppSelectRetailer } from '../../../components/pages/shopify/ShopifyAppSelectRetailer';

export function ShopifyIntegrationConfirmPage() {
  return (
    <PageLayout>
      <ShopifyAppSelectRetailer />
    </PageLayout>
  );
}
